// extracted by mini-css-extract-plugin
module.exports = {"ServiceCollections":"XT3B4","ServiceCollection":"_17BF0","CollectionHeading":"BjC8W","OverflowContainer":"_3X5W9","CollectionGrid":"_3OHLp"};